import { Modal, Typography, tokens } from "@sunrun/experience-ui-components";
import {
  POST_CAP_INSTALL_CUSTOMER_CONFIRM_MODAL_BODY,
  POST_CAP_INSTALL_CUSTOMER_CONFIRM_MODAL_TITLE,
} from "../../constants/capInstallScheduling";

type InstallCustomerConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  testId?: string;
  acknowledgeButtonTestId?: string;
};

const InstallCustomerConfirmModal: React.FC<
  InstallCustomerConfirmModalProps
> = ({
  open,
  onClose,
  testId = "post-cap-install-customer-confirm-modal",
  acknowledgeButtonTestId = "post-cap-install-customer-confirm-acknowledge",
}) => {
  if (!open) {
    return null;
  }

  return (
    <Modal
      testId={testId}
      type="warning"
      title={POST_CAP_INSTALL_CUSTOMER_CONFIRM_MODAL_TITLE}
      primaryButton={{
        text: "Acknowledge",
        onClick: onClose,
        testId: acknowledgeButtonTestId,
      }}
      onClose={onClose}
    >
      <Typography color={tokens.TINTS_OFF_WHITE_20}>
        {POST_CAP_INSTALL_CUSTOMER_CONFIRM_MODAL_BODY}
      </Typography>
    </Modal>
  );
};

export { InstallCustomerConfirmModal };
export type { InstallCustomerConfirmModalProps };
